// eslint-disable-next-line @typescript-eslint/ban-ts-comment -- FIXME https://tinyurl.com/eslint-fixme
// @ts-ignore @types not working?
import shouldForwardProp from '@styled-system/should-forward-prop';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types -- FIXME https://tinyurl.com/eslint-fixme
export const getStyledSystemConfig = () => ({
  shouldForwardProp: shouldForwardProp as (prop: string | number | symbol) => boolean,
});
